module.exports = __webpack_public_path__ + "img/01_sub_no.e4b2b822.svg";